import React, { useEffect, useState } from "react";
import "./Contact.css";
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaWhatsapp } from "react-icons/fa";
import Footer from "../Home/Footer";
import LeadForm from "../components/LeadForm";

const INDIA_MAP_EMBED =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.46512891372!2d78.40001199999999!3d17.437438!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9104e126e10d%3A0x785ca2c67313cde8!2sQHub%20-%20Coworking%20Space%20%7C%20Business%20Center%20%7C%20Conference%20Rooms%20%7C%20Virtual%20Offices%20%7C%20Plug%20and%20Play%20Offices!5e0!3m2!1sen!2sin!4v1768818358170!5m2!1sen!2sin";

const Contact = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setIsVisible(true)),
      { threshold: 0.1 }
    );
    document.querySelectorAll(".fade-in").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="contact-us-container">
        <h2 className="react-out-heading">Get Your Free Website Quote</h2>
        <p className="intro-text">
          Tell us about your business and we will call you within 24 hours with a custom plan.
          Or chat with us instantly on WhatsApp.
        </p>
        <a href="https://wa.me/919392014678?text=Hi!%20I%20want%20a%20website%20quote" className="contact-wa-link" target="_blank" rel="noopener noreferrer">
          <FaWhatsapp /> Chat on WhatsApp — Fastest Response
        </a>

        <div className={`contact-flex fade-in ${isVisible ? "show" : ""}`}>
          <div className="left-side">
            <div className="location-card">
              <h3><FaMapMarkerAlt className="location-icon" /> US Location</h3>
              <p>8720 Silverado Trail, Suite 207, McKinney, TX 75070</p>
              <div className="contact-details">
                <span><FaPhone className="location-icon" /> US: +1-201-581-5271</span>
              </div>
            </div>
            <div className="location-card">
              <h3><FaMapMarkerAlt className="location-icon" /> India Location</h3>
              <h4>Main Office</h4>
              <p>VISYS Cloud Technologies — QHub Madhapur, 4th Floor, near Madhapur Metro Station, Madhapur, Hyderabad, Telangana 500033</p>
              <div className="contact-details">
                <span><FaPhone className="location-icon" /> India: +91 9392014678</span>
                <a href="mailto:info@visyscloudtech.com"><FaEnvelope className="location-icon" /> info@visyscloudtech.com</a>
                <a href="mailto:support@ai4bazaar.com"><FaEnvelope className="location-icon" /> support@ai4bazaar.com</a>
              </div>
            </div>
            <div className="location-card map-card">
              <iframe src={INDIA_MAP_EMBED} title="VISYS Cloud Technologies India Office" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
              <div className="map-caption">
                <h4>VISYS Cloud Technologies</h4>
                <p>QHub-Madhapur, Hyderabad, Telangana 500033</p>
              </div>
            </div>
          </div>
          <div className="right-side">
            <LeadForm source="contact-page" />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
